import { taxonomyString } from 'utils/text';

export const ContentTypeHomeRoute = {
  ContentfulWebinar: '/webinar',
  ContentfulBlog: '/blog',
  ContentfulPodcast: '/podcasts',
  ContentfulTool: '/tools',
  ContentfulGatedContentPage: '/guides',
};

export const ctaTypeMap = {
  ContentfulGatedContentPage: 'Download Now',
  ContentfulBlog: 'Read Now',
  ContentfulWebinar: 'Register Now',
  ContentfulPodcast: 'Listen Now',
  ContentfulTool: 'Use Tool Now',
  ContentfulCaseStudy: 'Read Now',
};

export const ContentTypeCategory = {
  ContentfulWebinar: 'Webinar',
  ContentfulPodcast: 'Podcast',
  ContentfulBlog: 'Article',
  ContentfulGatedContentPage: 'Guide',
  ContentfulTool: 'Tool',
  SuccessStory: 'Success Story',
  ContentfulCaseStudy: 'Case Study',
};
export const ContentTypeHeadings = {
  ContentfulGatedContentPage: 'Guides',
  ContentfulBlog: 'Blogs',
  ContentfulWebinar: 'Webinars',
  ContentfulPodcast: 'Podcasts',
  ContentfulTool: 'Tools',
};

export const getImageSrc = (img) =>
  img?.cardImage ||
  img?.featuredImage?.image ||
  img?.cardPhoto?.image ||
  img?.coverPhoto?.image ||
  img?.featuredImage ||
  img?.assetThumbnail ||
  img?.cover ||
  img?.thumbnail ||
  img?.cardPhoto ||
  (img?.speakers?.length > 0 && img?.speakers[0]?.photo?.imageMobile);

export const getImageAlt = (img) =>
  img?.featuredImage?.title ||
  img?.assetThumbnail?.title ||
  img?.featuredImage?.alt ||
  img?.cardPhoto?.alt ||
  img?.coverPhoto?.alt;

export const getKicker = (content) => ContentTypeCategory[content.__typename];

export const getTitle = (content) =>
  content?.title ||
  content?.webinarTitle ||
  content?.podcastTitle ||
  content?.contentOfferTitle ||
  content?.internalName;

export const getCategory = (content) => content?.subTitle || taxonomyString(content?.seo?.taxonomy);

export const getExcerpt = (content) =>
  content?.excerpt?.excerpt ||
  content?.excerpt?.content?.[0]?.content?.[0]?.value ||
  content?.description?.description ||
  content?.podExcerpt?.podExcerpt;

export const getMainContent = (content) => content?.mainContent;

export const getCtaLink = (content) => content?.seo?.pageUrl || content?.slug;

export const getCtaLabel = (content) =>
  content.onDemandPage ? 'Watch Now' : `${ctaTypeMap[content.__typename]}`;

export const getCategories = (data) =>
  data.taxonomy?.level ||
  data?.category?.split(',')?.join(' • ') ||
  data?.seo?.taxonomy?.topics?.join(' • ') ||
  ContentTypeCategory[data.__typename] ||
  data?.subTitle ||
  data?.__typename?.replace(new RegExp(/contentful/, 'i'), '') ||
  'Tool';

export const getAllToolboxCardData = (content) => ({
  imgSrc: getImageSrc(content),
  imgAlt: getImageAlt(content),
  kicker: getKicker(content),
  title: getTitle(content),
  category: getCategory(content),
  excerpt: getExcerpt(content),
  mainContent: getMainContent(content),
  link: getCtaLink(content),
  linkLabel: getCtaLabel(content),
});

export const transformToolCard = (toolEntry) => ({
  __typename: 'ContentfulCard',
  title: toolEntry.internalName,
  description: { description: toolEntry?.excerpt?.excerpt || '' },
  cover: toolEntry.cardImage?.image || undefined,
  ctaText: 'Use Tool Now',
  ctaLink: `${toolEntry.seo?.pageUrl || ''}`,
  backColor: toolEntry.toolboxCardColor,
  industries: toolEntry?.seo?.taxonomy?.industries,
});
